module.exports = __webpack_public_path__ + "static/media/ireland-flag.51c0de41.png";